import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import TopBar from './TopBar'
import BottomNav from './BottomNav'
import { useAuthStore } from '@/store/useAuthStore'
import { useFamilyStore } from '@/store/useFamilyStore'
import { useTaskStore } from '@/store/useTaskStore'
import { useSupplyStore } from '@/store/useSupplyStore'

export default function MainLayout() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()

  const currentUserId = useAuthStore((state) => state.currentUserId)
  const fetchMembers = useFamilyStore((state) => state.fetchMembers)
  const fetchTasks = useTaskStore((state) => state.fetchTasks)
  const fetchCompletions = useTaskStore((state) => state.fetchCompletions)
  const fetchSupplies = useSupplyStore((state) => state.fetchSupplies)

  // Fetch all data on mount
  useEffect(() => {
    fetchMembers()
    fetchTasks()
    fetchCompletions()
    fetchSupplies()
  }, [fetchMembers, fetchTasks, fetchCompletions, fetchSupplies])

  // Redirect to user selection if no user selected (only on initial load)
  const members = useFamilyStore((state) => state.members)

  useEffect(() => {
    // Only redirect if we have members but no user selected
    if (members.length > 0 && !currentUserId) {
      navigate('/settings')
    }
  }, [members.length, currentUserId, navigate])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        pb: isMobile ? 8 : 0, // Add padding for bottom nav on mobile
        background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '300px',
          background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%)',
          zIndex: 0,
          pointerEvents: 'none',
        },
      }}
    >
      <TopBar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 3,
          pb: 3,
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Outlet />
      </Box>

      {isMobile && <BottomNav />}
    </Box>
  )
}
